module.exports = new __parcel__URL__("coin-blue.78b4366c.svg").toString();